export default function ObservationCard({ obs, onOpen, onQuickPerspective, showPseudonym }: any) {
  const tags = safeParse(obs.salience_tags)
  const anomaly = Math.round((obs.anomaly || 0.5) * 100)
  const hasRestored = !!obs.restoration_at

  return (
    <div className="field-card paper rounded-2xl p-4 cursor-pointer flex flex-col" onClick={onOpen}>
      <div className="text-[13px] leading-snug font-serif line-clamp-4 text-[#3f2e1e]">
        {obs.description}
      </div>

      <div className="mt-3 flex flex-wrap gap-1">
        {tags?.slice(0, 3).map((t: string) => (
          <span key={t} className="text-[10px] px-2 py-px rounded-full bg-[#e8e4d9] text-[#5c4633]">{t.replace(/-/g,' ')}</span>
        ))}
        {obs.salience_free && <span className="text-[10px] px-2 py-px rounded-full border border-[#d4c9b8]">{obs.salience_free.slice(0,22)}</span>}
      </div>

      <div className="mt-auto pt-3 flex items-center justify-between text-xs">
        <div className="flex items-center gap-2">
          <div className="w-16 h-1.5 bg-[#d4c9b8] rounded overflow-hidden">
            <div className="anomaly-bar" style={{ width: `${anomaly}%` }} />
          </div>
          <span className="tabular-nums text-[#5c4633]">{anomaly}%</span>
        </div>

        <div className="flex items-center gap-2 text-[#5c4633]">
          {obs.is_guest && <span className="guest-badge">witness</span>}
          {showPseudonym && obs.author_pseudonym && <span className="text-[10px]">{obs.author_pseudonym}</span>}
          {hasRestored && <span className="text-[10px] text-[#4a3f6b]">oriented</span>}
        </div>
      </div>

      <div className="mt-2 text-[10px] text-[#8b5e3c] flex gap-3">
        <span onClick={(e) => { e.stopPropagation(); onQuickPerspective?.('mother/caregiver', '') }} className="hover:underline">+ perspective</span>
        <span onClick={(e) => { e.stopPropagation(); onOpen() }} className="hover:underline">open</span>
      </div>
    </div>
  )
}

function safeParse(s: any) { try { return JSON.parse(s) } catch { return [] } }
